import api from "./axios";

export const chatPreferenceApi = async (payload) => {
  // payload = { thread_id, pinned?, muted?, favorite? }
  const { data } = await api.post(
    "chat/chat-thread-actions/preference/",
    payload
  );

  if (!data.success)
    throw new Error(data.message || "Failed to update preference");
  return data.data;
};
